// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3ovNw","additionalInfo":"AgreementModal_additionalInfo__2r1sp"};